import { CircularProgress, Select, Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"

import TimeGraph from "./TimeGraph"
import { TimeInterval } from "./types"
import { formatTime, renderAnalyticsMetric } from "./utils"

const TimeSpent = ({
  weeklyTimeSpentData = [],
  isCourse,
  totalTimeSpent,
  weeklyTimeSpent,
  timeIntervalOptions,
  selectedTimeInterval,
  setSelectedTimeInterval,
  timeGraphLoading = false,
  thisWeekTimeSpent,
}: {
  weeklyTimeSpentData?: number[]
  isCourse: boolean
  totalTimeSpent?: number | null
  weeklyTimeSpent?: number | null
  selectedTimeInterval: { value: TimeInterval; label: string }
  setSelectedTimeInterval: (value: {
    value: TimeInterval
    label: string
  }) => void
  timeIntervalOptions: { value: TimeInterval; label: string }[]
  timeGraphLoading?: boolean
  thisWeekTimeSpent?: number
}) => {
  const timeInterval = selectedTimeInterval.value

  if (isCourse)
    return (
      <div className="flex h-full flex-col justify-between">
        <Typography className="mb-4 text-strong text-muted">
          Time Spent
        </Typography>
        <div className="flex items-end justify-between">
          <div className="flex flex-col gap-0.5">
            <Typography className="text-xs font-medium text-onSurface-400">
              Total
            </Typography>
            {renderAnalyticsMetric(
              totalTimeSpent,
              ({ isNum, formattedValue }) => (
                <Typography
                  variant="title1"
                  className={clsx("text-onSurface-900", {
                    "text-onSurface-400 !font-thin": !isNum,
                  })}
                >
                  {formatTime(Number(formattedValue))}
                </Typography>
              )
            )}
          </div>
          <div className="mr-3 flex flex-col gap-0.5">
            <Typography className="text-xs font-medium text-onSurface-400">
              Weekly Avg.
            </Typography>
            {renderAnalyticsMetric(
              weeklyTimeSpent,
              ({ isNum, formattedValue }) => (
                <Typography
                  variant="title2"
                  className={clsx("text-onSurface-900", {
                    "text-onSurface-400 !font-thin": !isNum,
                  })}
                >
                  {formatTime(Number(formattedValue))}
                </Typography>
              )
            )}
          </div>
        </div>
      </div>
    )

  return (
    <div className="flex h-full flex-col justify-between">
      <div className="mb-2 flex items-start justify-between">
        <Typography className="mb-4 text-strong text-muted">
          Time Spent
        </Typography>
        <Select
          className="w-15 [&>div>div>div>div]:!text-sm [&>div>div>div>div]:!font-semibold [&>div>div>div>div]:!text-onSurface-700 [&>div>div>div>span]:w-0 [&>div>div]:!rounded-xl [&>div>div]:!border-onSurface-300 [&>div>div]:!bg-[#fcfcfc]"
          placeholder="Modules"
          options={timeIntervalOptions}
          onChange={val => {
            if (!val) return
            setSelectedTimeInterval(val)
          }}
          value={selectedTimeInterval}
        />
      </div>
      <div>
        {timeGraphLoading ? (
          <div className="mb-6 flex h-full items-center justify-center">
            <CircularProgress size="md" />
          </div>
        ) : (
          <>
            <div className="mb-2 flex justify-between">
              <div className="flex flex-col gap-0.5">
                <Typography className="text-xs font-medium text-onSurface-400">
                  Total this {timeInterval}
                </Typography>
                {renderAnalyticsMetric(
                  thisWeekTimeSpent,
                  ({ isNum, formattedValue }) => (
                    <Typography
                      variant="title2"
                      className={clsx("text-onSurface-900", {
                        "text-onSurface-400 !font-thin": !isNum,
                      })}
                    >
                      {formatTime(Number(formattedValue))}
                    </Typography>
                  )
                )}
              </div>
              <div>
                <TimeGraph data={weeklyTimeSpentData} />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default TimeSpent
